import BasePerimeter from '@/kindergarten/perimeters/BasePerimiter';

export default new BasePerimeter({
  purpose: 'my_hp_base_role',

  can: {
    route() {
      return this.child && (this.isAdmin() || this.isMyHp() || this.isBaseRole());
    },
  },
});



// WEBPACK FOOTER //
// ./src/kindergarten/perimeters/MyHpBasePerimeter.js